// extracted by mini-css-extract-plugin
export default {"container":"Products_container__cFCgQ","products":"Products_products__Hzjxt","menu":"Products_menu__dt7yT","list":"Products_list__947vE","product":"Products_product__0U4Km"};